import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["imgSrc"];
import { Box } from 'foundations-components/transitional/components/Box';
import { Image } from 'foundations-components/transitional/components/Image';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { InsertImageIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const AssetThumbnail = _ref => {
  let {
      imgSrc
    } = _ref,
    styleProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Box, Object.assign({
    backgroundColor: "fill-tertiary-default",
    overflow: "hidden",
    inlineSize: "fit-content",
    alignSelf: "center",
    blockSize: "100%",
    display: "flex",
    alignItems: "center"
  }, styleProps, {
    children: imgSrc ? /*#__PURE__*/_jsx(Image, {
      src: imgSrc,
      blockSize: "100%",
      objectFit: "contain",
      "data-test-id": "asset-thumbnail"
    }) : /*#__PURE__*/_jsx(IconHolder, {
      icon: InsertImageIcon,
      justifyContent: "center",
      alignItems: "center",
      blockSize: "100%",
      inlineSize: "100%",
      color: "icon-interactive-default",
      size: "700",
      "data-test-id": "thumbnail-fallback"
    })
  }));
};
export default AssetThumbnail;